var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoggedIn)?_c('TheDrawer',[_c('TheHome')],1):_c('Login',{key:"the-login",attrs:{"visible":!_vm.isLoggedIn && !_vm.isPending}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }